import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import animated from 'animate.css'
Vue.config.productionTip = false
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-contrib-hls";
Vue.prototype.$video = videojs;
let echarts = require('echarts');
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.use(animated);
// import vConsole from 'vconsole'
// new vConsole()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
